import React from 'react';

interface IOptionsProps {
  size?: string | number;
}

export default function Options({ size = '100%' }: IOptionsProps) {
  return (
    <svg
      width={size}
      height={size}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 124 88"
      version="1.1"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect fill="#404040" x="0" y="0" width="124" height="16" rx="8" />
        <rect fill="#404040" x="0" y="36" width="124" height="16" rx="8" />
        <rect fill="#404040" x="0" y="72" width="124" height="16" rx="8" />
      </g>
    </svg>
  );
}
